'use client';
import e from 'prop-types';
import e__default from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { SelectionSetContext } from './selection-set.context.js';
import { filterProps } from '../core/core.utils.js';
import { conditionalPropType } from '../../prop-types/conditional.prop-type.js';
import { nullishPropType } from '../../prop-types/nullish.prop-types.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useId } from '../../hooks/use-id.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {}, o = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, n[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        n.push.apply(n, o);
    }
    return n;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    }), e;
}
let isMultiSelect = (e)=>'multi-select' === e.variant, u = {
    skin: e.oneOf([
        'standard',
        'buttons',
        'simple-column',
        'tiles-horizontal',
        'tiles-vertical',
        'tiles-mini'
    ]),
    name: e.string,
    variant: e.oneOf([
        'single-select',
        'multi-select'
    ]),
    imageWidth: e.oneOf([
        'fixed',
        'proportional'
    ]),
    imageVerticalAlignment: e.oneOf([
        'cover',
        'top',
        'center'
    ]),
    tileContentsPadding: e.oneOf([
        'standard',
        'tight'
    ]),
    tileImagePadding: e.oneOf([
        'standard',
        'wide'
    ]),
    selectedValue: conditionalPropType(isMultiSelect, nullishPropType, e.string),
    defaultSelectedValue: conditionalPropType(isMultiSelect, nullishPropType, e.string),
    onSelectedValueChange: conditionalPropType(isMultiSelect, nullishPropType, e.func),
    selectedValues: conditionalPropType(isMultiSelect, e.objectOf(e.bool.isRequired), nullishPropType),
    defaultSelectedValues: conditionalPropType(isMultiSelect, e.objectOf(e.bool.isRequired), nullishPropType),
    onSelectedValuesChange: conditionalPropType(isMultiSelect, e.func, nullishPropType)
}, f = Object.keys(u);
const SelectionSet = renderWithRef('SelectionSet', u, (e, r)=>{
    useComponentStylesLoaded('SelectionSet', SWAN_STYLE_KEY_MAP.selectionSet);
    let { children: c, variant: d = 'single-select', skin: u = 'standard', imageWidth: m = 'fixed', imageVerticalAlignment: g = 'cover', tileContentsPadding: b = 'standard', tileImagePadding: O = 'standard', selectedValue: y, defaultSelectedValue: w = null, onSelectedValueChange: S, selectedValues: j, defaultSelectedValues: h = {}, onSelectedValuesChange: v, name: _ } = e, P = new Set([
        'swan-selection-set'
    ]);
    'standard' !== u && P.add(`swan-selection-set-skin-${u}`), 'simple-column' === u && P.add('swan-selection-set-show-inputs'), 'proportional' === m && P.add('swan-selection-set-image-width-proportional'), 'center' === g && P.add('swan-selection-set-image-vertical-alignment-center'), 'tight' === b && P.add('swan-selection-set-tile-contents-padding-tight'), 'wide' === O && P.add('swan-selection-set-tile-image-padding-wide');
    let V = useId(_), [C, k] = useControllableValue({
        value: y,
        onChange: S || void 0,
        defaultValue: w,
        defaultOnChange: (e, ...t)=>{
            let [n] = t;
            e(n);
        }
    }), [M, D] = useControllableValue({
        value: null != j ? j : void 0,
        onChange: v || void 0,
        defaultValue: h || {},
        defaultOnChange: (e, ...t)=>{
            let [n] = t;
            e(n);
        }
    }), x = _object_spread_props(_object_spread({}, filterProps(e, null, null)), {
        role: 'single-select' === d ? 'radiogroup' : 'group'
    });
    return e__default.createElement(SelectionSetContext.Provider, {
        value: {
            name: V,
            variant: d,
            skin: u,
            imageWidth: m,
            imageVerticalAlignment: g,
            tileContentsPadding: b,
            tileImagePadding: O,
            selectedValue: C,
            onSelectedValueChange: k,
            selectedValues: M,
            onSelectedValuesChange: D
        }
    }, e__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: r,
        propKeysToRemove: f,
        classNames: P,
        props: _object_spread({}, e, x)
    }, c));
});

export { SelectionSet };
